/**
 * İşlem Seç Modal - service-contents'ten kategorilere göre işlem listesi
 * Yapılan işlemler için MongoDB/content'lerden işlem seçimi
 */
import React, { useState, useEffect, useCallback } from 'react';
import { fetchMobileServiceContents } from '../services/mobileAppointmentService';

const IslemSecModal = ({ isOpen, onClose, onSeçilenleriEkle }) => {
  const [islemlerKategorili, setIslemlerKategorili] = useState([]);
  const [loading, setLoading] = useState(false);
  const [expandedKategoriler, setExpandedKategoriler] = useState(new Set());
  const [selectedIds, setSelectedIds] = useState(new Set()); // icerik _id

  const loadContents = useCallback(async () => {
    setLoading(true);
    try {
      const res = await fetchMobileServiceContents(null);
      const list = res?.veri?.islemler ?? res?.veri?.islemler ?? [];
      setIslemlerKategorili(Array.isArray(list) ? list : []);
      if (list?.length) {
        setExpandedKategoriler(new Set(list.map((k) => k.kategoriId || k._id || k.kategoriAdi).filter(Boolean)));
      }
    } catch {
      setIslemlerKategorili([]);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    if (isOpen) {
      setSelectedIds(new Set());
      loadContents();
    }
  }, [isOpen, loadContents]);

  const toggleKategori = (key) => {
    setExpandedKategoriler((prev) => {
      const next = new Set(prev);
      if (next.has(key)) next.delete(key);
      else next.add(key);
      return next;
    });
  };

  const toggleSelect = (icerikId) => {
    setSelectedIds((prev) => {
      const next = new Set(prev);
      if (next.has(icerikId)) next.delete(icerikId);
      else next.add(icerikId);
      return next;
    });
  };

  const handleSeçilenleriEkle = () => {
    const secilenler = [];
    islemlerKategorili.forEach((kat) => {
      (kat.icerikler || []).forEach((ic) => {
        const icId = ic._id || ic.id;
        if (icId && selectedIds.has(icId)) {
          secilenler.push({
            kategoriId: kat.kategoriId || null,
            islemAdi: ic.icerikAdi || ic.urunAdi || ic.ad || '',
            fiyat: ic.fiyatGarantiHarici ?? ic.fiyat ?? 0,
            aciklama: '',
          });
        }
      });
    });
    onSeçilenleriEkle?.(secilenler);
    onClose?.();
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onClose} role="dialog" aria-modal="true">
      <div className="modal-content" onClick={(e) => e.stopPropagation()} style={{ maxWidth: '560px', width: '95%', maxHeight: '85vh' }}>
        <div className="modal-header">
          <h2>Yapılan İşlem Seç</h2>
          <button type="button" className="modal-close-btn" onClick={onClose} aria-label="Kapat">
            <i className="fas fa-times"></i>
          </button>
        </div>
        <div className="modal-body" style={{ overflowY: 'auto', padding: '16px' }}>
          {loading ? (
            <div style={{ padding: '24px', textAlign: 'center', color: 'var(--text-gray)' }}>
              <i className="fas fa-spinner fa-spin" style={{ fontSize: '24px', marginRight: '8px' }}></i>
              Yükleniyor...
            </div>
          ) : islemlerKategorili.length === 0 ? (
            <div style={{ padding: '24px', textAlign: 'center', color: 'var(--text-gray)' }}>
              İşlem kategorisi bulunamadı. Önce İçerik Yönetimi’nden işlem ekleyin.
            </div>
          ) : (
            <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
              {islemlerKategorili.map((kat, katIdx) => {
                const katKey = kat.kategoriId || kat._id || kat.kategoriAdi || `kat-${katIdx}`;
                const icerikler = kat.icerikler ?? [];
                const isExpanded = expandedKategoriler.has(katKey);

                return (
                  <div key={katKey} style={{ border: '1px solid #e2e8f0', borderRadius: '8px', overflow: 'hidden' }}>
                    <button
                      type="button"
                      onClick={() => toggleKategori(katKey)}
                      style={{
                        width: '100%',
                        padding: '12px 16px',
                        background: '#f8fafc',
                        border: 'none',
                        cursor: 'pointer',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '8px',
                        textAlign: 'left',
                        fontWeight: 600,
                        color: 'var(--text-dark)',
                        fontSize: '14px',
                      }}
                    >
                      <i className={`fas fa-chevron-${isExpanded ? 'down' : 'right'}`} style={{ fontSize: '12px', color: '#64748b' }}></i>
                      {kat.kategoriAdi || kat.ad || 'Kategori'}
                    </button>
                    {isExpanded && (
                      <div style={{ padding: '8px 0', background: '#fff' }}>
                        {icerikler.length === 0 ? (
                          <div style={{ padding: '12px 16px', fontSize: '13px', color: '#64748b' }}>Bu kategoride işlem yok.</div>
                        ) : (
                          icerikler.map((ic) => {
                            const icId = ic._id || ic.id;
                            const checked = selectedIds.has(icId);
                            const ad = ic.icerikAdi || ic.urunAdi || ic.ad || '—';
                            const kod = ic.icerikKodu || ic.urunKodu || ic.kod || '';
                            const fiyat = ic.fiyat ?? ic.fiyatgaranti ?? 0;

                            return (
                              <label
                                key={icId}
                                style={{
                                  display: 'flex',
                                  alignItems: 'center',
                                  gap: '12px',
                                  padding: '10px 16px',
                                  cursor: 'pointer',
                                  transition: 'background 0.15s',
                                }}
                                onMouseEnter={(e) => {
                                  e.currentTarget.style.background = '#f8fafc';
                                }}
                                onMouseLeave={(e) => {
                                  e.currentTarget.style.background = 'transparent';
                                }}
                              >
                                <input
                                  type="checkbox"
                                  checked={checked}
                                  onChange={() => toggleSelect(icId)}
                                  style={{ width: '18px', height: '18px', flexShrink: 0 }}
                                />
                                <div style={{ flex: 1, minWidth: 0 }}>
                                  <div style={{ fontWeight: 500, color: 'var(--text-dark)', fontSize: '14px' }}>{ad}</div>
                                  {(kod || fiyat != null) && (
                                    <div style={{ fontSize: '12px', color: '#64748b', marginTop: '2px' }}>
                                      {kod && `Kod: ${kod}`}
                                      {kod && fiyat != null && ' · '}
                                      {fiyat != null && `${Number(fiyat)} ₺`}
                                    </div>
                                  )}
                                </div>
                              </label>
                            );
                          })
                        )}
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          )}
        </div>
        <div className="modal-footer" style={{ padding: '16px', borderTop: '1px solid #e2e8f0' }}>
          <button type="button" className="secondary-btn" onClick={onClose}>
            İptal
          </button>
          <button
            type="button"
            className="primary-btn"
            onClick={handleSeçilenleriEkle}
            disabled={selectedIds.size === 0}
          >
            Seçilenleri Ekle ({selectedIds.size})
          </button>
        </div>
      </div>
    </div>
  );
};

export default IslemSecModal;
